import {$wrapSelectionInMarkNode, MarkNode, SerializedMarkNode} from '@lexical/mark';
import {$applyNodeReplacement, LexicalNode, NodeKey, RangeSelection, Spread} from 'lexical';

import styles from './ExcludeWordcountNode.module.css';

export type SerializedExcludeWordcountNode = Spread<
  {
    className?: string;
    isDeletable?: boolean;
  },
  SerializedMarkNode
>;

export class ExcludeWordcountNode extends MarkNode {
  __className?: string;
  __isDeletable?: boolean;

  static getType(): string {
    return 'exclude-wordcount-mark';
  }

  static importDOM(): null {
    return null;
  }

  static clone(node: ExcludeWordcountNode): ExcludeWordcountNode {
    return new ExcludeWordcountNode(
      [...node.__ids],
      node.__className,
      node.__isDeletable,
      node.__key
    );
  }

  constructor(ids: string[], className?: string, isDeletable?: boolean, key?: NodeKey) {
    super(ids, key);
    this.__className = className;
    this.__isDeletable = isDeletable;
  }

  getIsDeletable(): boolean {
    return this.__isDeletable ?? true;
  }

  createDOM(): HTMLElement {
    const span = document.createElement('span');
    span.classList.add(styles.excludeWordcount);
    if (!this.getIsDeletable()) {
      span.classList.add(styles.protected);
    }
    span.setAttribute('data-exclude-wordcount-id', this.__ids[0]);
    const tooltip = this.getIsDeletable()
      ? 'Excluded from wordcount'
      : 'Excluded from wordcount (protected)';
    span.setAttribute('data-tooltip', tooltip);

    return span;
  }

  updateDOM(): boolean {
    return false;
  }

  exportJSON(): SerializedExcludeWordcountNode {
    return {
      ...super.exportJSON(),
      type: 'exclude-wordcount-mark',
      version: 1,
      className: this.__className,
      isDeletable: this.__isDeletable,
    };
  }

  static importJSON(serializedNode: SerializedExcludeWordcountNode): ExcludeWordcountNode {
    return new ExcludeWordcountNode(
      serializedNode.ids,
      serializedNode.className,
      serializedNode.isDeletable
    );
  }
}

export function $createExcludeWordcountNode(
  id: string,
  className?: string,
  isDeletable?: boolean
): ExcludeWordcountNode {
  return $applyNodeReplacement(new ExcludeWordcountNode([id], className, isDeletable));
}

export function $wrapSelectionInExcludeWordcountNode(
  selection: RangeSelection,
  id: string,
  className?: string,
  isDeletable?: boolean
) {
  $wrapSelectionInMarkNode(selection, false, id, () =>
    $createExcludeWordcountNode(id, className, isDeletable)
  );
}

export function $isExcludeWordcountNode(
  node: LexicalNode | null | undefined
): node is ExcludeWordcountNode {
  return node instanceof ExcludeWordcountNode;
}
